import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/owlBranding/cards.webp'

export const Cards: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'cards'} />
)
